// extracted by mini-css-extract-plugin
module.exports = {"heading":"PrivacyPolicyPage_heading__A3Yih","content":"PrivacyPolicyPage_content__2WS5I"};